import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";

function WithDraw() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [bank, setBank] = useState(null);
    const [newMoney, setNewMoney] = useState(null);
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [load, setLoad] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);

    const navigate = useNavigate();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();

    const handleBackClick = () => {
        navigate(-1);
    };

    useEffect(() => {
        // 1. Lấy thông tin User mới nhất
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));
            })
            .catch(() => localStorage.removeItem("user"));

        // 2. Lấy thông tin ngân hàng đã liên kết
        axios.get(`${process.env.REACT_APP_API_URL}/bank/getBank`)
            .then((res) => {
                if (res.data.data && res.data.data.length > 0) {
                    setBank(res.data.data);
                } else {
                    setBank(null);
                }
            })
            .catch(() => setBank(null))
            .finally(() => setInitialLoading(false));

        // 3. Lấy cài đặt rút tiền (min/max)
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`).then((res) => {
            setSetting(res.data.data[0]);
            localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
        });
    }, []);

    const onSubmit = (data) => {
        if (load) return;

        const rawMoney = Number(data.money.replaceAll(".", "").replaceAll(",", ""));

        // Kiểm tra số dư
        if (rawMoney > profile.money) {
            setError("money", { type: "manual", message: "Số dư không đủ" });
            return;
        }

        // Kiểm tra tiền hợp lệ
        if (rawMoney <= 0 || isNaN(rawMoney)) {
            setError("money", { type: "manual", message: "Số tiền không hợp lệ" });
            return;
        }

        // Kiểm tra min/max rút
        if (rawMoney < setting?.minrut) {
            swal("Chú ý", `Rút tối thiểu là ${(setting?.minrut).toLocaleString('vi-VN')}₫`, "warning");
            return;
        }
        if (rawMoney > setting?.maxrut) {
            swal("Chú ý", `Rút tối đa là ${(setting?.maxrut).toLocaleString('vi-VN')}₫`, "warning");
            return;
        }

        const formData = {
            money: rawMoney,
            type_payment: "RÚT",
            detail: data.detail,
            status_payment: "Pending",
            user: profile._id,
            paypwd: data.paypwd
        };

        setLoad(true);
        axios.post(`${process.env.REACT_APP_API_URL}/payment/withDraw`, formData)
            .then(() => {
                swal("Thông báo", "Tạo yêu cầu rút tiền thành công!", "success")
                .then(() => navigate("/profile"));
            })
            .catch((err) => {
                setLoad(false);
                // Hiển thị lỗi từ Backend (Ví dụ: "Bạn cần nạp tiền lần đầu...")
                const errorMsg = err.response?.data?.message || "Đã có lỗi xảy ra";
                swal("Thất bại", errorMsg !== "internal server error" ? errorMsg : "Lỗi hệ thống", "error");
            });
    };

    return (
        <>
            {(load || initialLoading) && (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            )}

            <div className="title-top">
                <div className="back" onClick={handleBackClick}>
                    <KeyboardArrowLeftOutlinedIcon />
                </div>
                <h1 className="title-h1">Rút tiền</h1>
            </div>

            <div className="main">
                <AnimatedPage>
                    <div className="content_profile" style={{ margin: "0.5rem 0 0" }}>
                        <div className="balance-box" style={{ padding: "1rem", background: "#fff", marginBottom: "0.5rem", borderRadius: "8px" }}>
                            <p style={{ color: "#666", fontSize: "14px" }}>Số dư khả dụng</p>
                            <h2 style={{ color: "#d32f2f", margin: "5px 0" }}>{profile?.money?.toLocaleString('vi-VN')}₫</h2>
                        </div>

                        <form className="form-lg form-box" onSubmit={handleSubmit(onSubmit)} style={{ margin: "0" }}>
                            <div>
                                {bank == null ? (
                                    <div style={{ textAlign: "center", padding: "20px" }}>
                                        <p style={{ marginBottom: "15px" }}>Bạn chưa liên kết tài khoản ngân hàng</p>
                                        <Link to="/addbank" className="btn-submit" style={{ display: "block", textDecoration: "none" }}>
                                            Liên kết ngay
                                        </Link>
                                    </div>
                                ) : (
                                    <>
                                        <div className="input">
                                            <label>Số tiền rút</label>
                                            <input
                                                className="ipadd"
                                                type="text"
                                                value={newMoney}
                                                {...register("money", { required: true })}
                                                placeholder="0₫"
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/\D/g, "");
                                                    setNewMoney(val ? Number(val).toLocaleString('vi-VN') : "");
                                                }}
                                            />
                                            {errors.money && <p className="error-text" style={{ color: "red", fontSize: "12px" }}>{errors.money.message}</p>}
                                        </div>

                                        <div className="input">
                                            <label>Mật khẩu rút tiền</label>
                                            <input
                                                className="ipadd"
                                                type="password"
                                                {...register("paypwd", { required: true })}
                                                placeholder="Nhập mật khẩu"
                                            />
                                            {errors.paypwd && <p className="error-text" style={{ color: "red", fontSize: "12px" }}>{errors.paypwd.message}</p>}
                                        </div>

                                        <div className="input">
                                            <label>Nhận tiền về</label>
                                            <select
                                                className="ipadd"
                                                style={{ color: "#333", width: "100%" }}
                                                {...register("detail", { required: "Vui lòng chọn ngân hàng" })}
                                            >
                                                <option value="">-- Chọn ngân hàng --</option>
                                                {bank.map((item, index) => (
                                                    <option key={index} value={`${item.name_bank} - ${item.fullname} - ${item.stk} `}>
                                                        {item.name_bank}-{item.fullname}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.detail && <p className="error-text" style={{ color: "red", fontSize: "12px" }}>{errors.detail.message}</p>}
                                        </div>

                                        <div className="note-withdraw" style={{ padding: "10px", background: "#fffbe6", border: "1px solid #ffe58f", borderRadius: "5px", marginBottom: "15px" }}>
                                            <p style={{ fontSize: "12px", color: "#856404" }}>
                                                * Lưu ý: Rút tiền được xử lý tự động, sau 15p không nhận được tiền nhắn tin chăm sóc khách hàng để được hỗ trợ nhanh nhất.
                                            </p>
                                        </div>

                                        <button type="submit" className="btn-submit" disabled={load}>
                                            {load ? "Đang xử lý..." : "Xác nhận rút tiền"}
                                        </button>
                                    </>
                                )}
                            </div>
                        </form>
                    </div>
                </AnimatedPage>
            </div>
            <Footer />
        </>
    );
}

export default WithDraw;